import { TFunction } from "i18next";
import { z } from "zod";

export const getEquipmentFormSchema = (t: TFunction) => {
  return z
    .object({
      captureId: z.number().int().positive().nullable().optional(),
      location: z.string().nullable().optional(),
      equipmentType: z.string().nullable().optional(),
      equipmentBrandId: z.number().int().positive().nullable().optional(),
      equipmentModel: z.string().nullable().optional(),
      serialNumber: z.string().nullable().optional(),
      notes: z.string().nullable().optional(),
      status: z.enum(["available", "unavailable", "damaged"]),
      damagedDate: z.string().nullable().optional(),
      maintenanceDate: z.string().nullable().optional(),
      maintenanceAlertsEnabled: z.boolean().optional(),
      maintenanceAlertDaysBefore: z.number().min(0).optional(),
      maintenanceAlertIntervalDays: z.number().min(1).optional(),
      maintenanceNotificationUserIds: z.array(z.number().positive()).nullable().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.status === "damaged" && !data.damagedDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["damagedDate"],
          message: t("warehouse.equipment.damaged-date-required"),
        });
      }
    });
};

export type EquipmentFormType = z.infer<ReturnType<typeof getEquipmentFormSchema>>;